import BaseModal from '@/components/customUI/Modals';
import { Dispatch, FC, SetStateAction } from 'react';
import InitiateDownload from './InitiateDownload';
import Download from '@/components/svg/Download';
import CSVFilesListView from './CSVFilesListView';

type BaseModalProps = {
  testId: string | undefined;
  testStatus: string;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  isRespCsvGenerated: boolean | null;
};

const DownloadResultModal: FC<BaseModalProps> = ({
  open,
  testId,
  testStatus,
  setOpen,
  isRespCsvGenerated
}) => {
  const ButtonLogo = () => {
    return (
      <span
        className={
          'text-white h-full  text-sm flex justify-center items-center gap-2'
        }>
        <Download /> Response
      </span>
    );
  };
  return (
    <BaseModal
      ButtonLogo={ButtonLogo}
      buttonProps={{ id: 'download-test-response' }}
      open={open}
      modalClass="max-w-[90%] max-h-[80%] "
      buttonClass="bg-[#0A3690] h-10"
      dialogTitle="Download Response Files"
      setOpen={setOpen}>
      <hr />
      <div className="flex justify-center items-center">
        {testStatus !== 'COMPLETED' ? (
          'Test is not yet completed, please check later!!'
        ) : isRespCsvGenerated === null ? (
          <InitiateDownload
            setOpen={setOpen}
            testId={testId}
          />
        ) : isRespCsvGenerated === true ? (
          <CSVFilesListView
            setOpen={setOpen}
            testId={testId}
          />
        ) : isRespCsvGenerated === false ? (
          'CSV files generation is still in progress, please check again after sometime!!'
        ) : (
          'Something went wrong!!'
        )}
      </div>
    </BaseModal>
  );
};

export default DownloadResultModal;
